import { render, staticRenderFns } from "./openInfoDetail.vue?vue&type=template&id=3c3aa5e8&scoped=true"
import script from "./openInfoDetail.vue?vue&type=script&lang=js"
export * from "./openInfoDetail.vue?vue&type=script&lang=js"
import style0 from "./openInfoDetail.vue?vue&type=style&index=0&id=3c3aa5e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../usr/local/node_16.9.1/lib/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3aa5e8",
  null
  
)

export default component.exports